import React from "react";
import { useTranslation } from "react-i18next";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";

const Screenshot = () => {
	const { t } = useTranslation();
	return (
		<div className="c__noData">
			<CautionIcon />
			<p className="main">
				{t("pages.myPage.PluginPage.PluginDetailModal.components.c__noData")}
			</p>
		</div>
	);
};

export default Screenshot;
